const About = () => {
  return (
    <>
    <style>{`
  .about-section {
    padding: 80px 20px;
    background: #f9fafc;
    font-family: 'Poppins', sans-serif;
  }

  .about-container {
    max-width: 1200px;
    margin: auto;
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 50px;
    align-items: flex-start;
  }

  .about-title {
    font-size: 36px;
    color: #1e293b;
    margin-bottom: 20px;
  }

  .about-text p {
    font-size: 16px;
    line-height: 1.9;
    color: #475569;
  }

  .about-image {
    width: 100%;
    height: auto;
    border-radius: 16px;
    box-shadow: 0 15px 35px rgba(0,0,0,0.15);
    object-fit: cover;
  }

  /* WHY CHOOSE */
  .why-choose {
    margin-top: 25px;
    padding: 22px;
    background: #f8fbff;
    border-radius: 14px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }

  .why-choose h3 {
    text-align: center;
    font-size: 22px;
    margin-bottom: 18px;
    color: #1e3a8a;
  }

  .choose-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .choose-item {
    display: flex;
    align-items: center;
    gap: 12px;
    background: white;
    padding: 14px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #334155;
    transition: 0.3s ease;
  }

  .choose-item span {
    font-size: 22px;
  }

  .choose-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 18px rgba(30, 58, 138, 0.2);
  }

  .management-desk {
    margin-top: 35px;
    padding-top: 20px;
    border-top: 2px solid #e2e8f0;
  }

  .management-desk h3 {
    font-size: 24px;
    margin-bottom: 15px;
    color: #0f172a;
  }

  .manager h4 {
    color: #1d4ed8;
    margin-bottom: 6px;
  }

  /* ---------- TABLET ---------- */
  @media (max-width: 1024px) {
    .about-container {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .about-title {
      font-size: 30px;
      text-align: center;
    }

    .about-text p {
      font-size: 15px;
    }

    .why-choose {
      margin-top: 30px;
    }
  }

  /* ---------- MOBILE ---------- */
  @media (max-width: 600px) {
    .about-section {
      padding: 50px 15px;
    }

    .about-title {
      font-size: 24px;
      text-align: center;
    }

    .about-text p {
      font-size: 14px;
      line-height: 1.7;
    }

    .choose-grid {
      grid-template-columns: 1fr;
    }

    .choose-item {
      font-size: 14px;
      padding: 12px;
    }

    .why-choose h3 {
      font-size: 18px;
    }

    .management-desk h3 {
      font-size: 20px;
      text-align: center;
    }

    .manager h4 {
      font-size: 16px;
    }
  }
`}</style>

      <section id="about" className="about-section">
        <div className="about-container">

          {/* LEFT SIDE – JOURNEY TEXT (FIXED & SAFE) */}
          <div className="about-text">
            <h2 className="about-title">A Journey of 20 Years</h2>

            <p>
              <strong>A Journey of 20 Years: From a Dream to a Destination</strong><br /><br />
              The story of New Aryaveer Senior Secondary School began with a simple yet powerful thought:
              <em> “Why should the children of Tal be deprived of world-class education?”</em>
              <br /><br />
              Founded on <strong>25th June 2006</strong> by
              <strong> Mr. Krishna Singh Sisodiya</strong> and
              <strong> Mr. Jitendra Singh Sisodiya</strong>, Aryaveer grew from a humble
              beginning to a premier institution.
            </p>

            <div className="management-desk">
              <h3>Management Desk</h3>

              <div className="manager">
                <h4>Chairman – Mr. Krishna Singh Sisodiya</h4>
                <p>
                  “Education is the greatest energy one can possess. Our mission is
                  to nurture talent that can change the world.”
                </p>
              </div>

              <div className="manager">
                <h4>Director – Mr. Jitendra Singh Sisodiya</h4>
                <p>
                  “Knowledge enables strength. We believe in 360° development of
                  every student.”
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE – IMAGE + WHY CHOOSE */}
          <div>
            <img src="/images/function.jpg.webp" alt="Students" className="about-image" />

            <div className="why-choose">
              <h3>Why Choose Our Institution</h3>

              <div className="choose-grid">
                <div className="choose-item">
                  <span>🎓</span>
                  <p>Experienced & Qualified Faculty</p>
                </div>
                <div className="choose-item">
                  <span>🏫</span>
                  <p>Well-equipped Campus</p>
                </div>
                <div className="choose-item">
                  <span>📚</span>
                  <p>Quality Education Since 2006</p>
                </div>
                <div className="choose-item">
                  <span>🤝</span>
                  <p>Student-Focused Learning</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;
